import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { TextInput, SelectInput, PrimaryButton } from './common/FormControls';

const Accounts = () => {
  const [claims, setClaims] = useState([]);
  const [debtors, setDebtors] = useState([]);
  const [creditors, setCreditors] = useState([]);
  const [claimForm, setClaimForm] = useState({
    patientId: '',
    insuranceId: '',
    amount: 0,
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [claimsRes, debtorsRes, creditorsRes] = await Promise.all([
        axios.get(`${window.location.protocol}//${window.location.hostname}/api/claims/claims`),
        axios.get(`${window.location.protocol}//${window.location.hostname}/api/claims/debtors`),
        axios.get(`${window.location.protocol}//${window.location.hostname}/api/claims/creditors`),
      ]);
      setClaims(claimsRes.data);
      setDebtors(debtorsRes.data);
      setCreditors(creditorsRes.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleClaimSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${window.location.protocol}//${window.location.hostname}/api/claims/claims`, claimForm);
      setClaimForm({
        patientId: '',
        insuranceId: '',
        amount: 0,
      });
      fetchData();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="space-y-8">
      <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
        <h2 className="text-2xl font-semibold text-slate-800 mb-4">Accounts</h2>
        <h3 className="text-lg font-medium text-slate-700 mb-3">Submit Claim</h3>
        <form onSubmit={handleClaimSubmit} className="space-y-4">
          <TextInput
            label="Patient ID"
            name="patientId"
            value={claimForm.patientId}
            onChange={(e) => setClaimForm({ ...claimForm, patientId: e.target.value })}
            required
          />
          <TextInput
            label="Insurance ID"
            name="insuranceId"
            value={claimForm.insuranceId}
            onChange={(e) => setClaimForm({ ...claimForm, insuranceId: e.target.value })}
          />
          <TextInput
            label="Amount"
            name="amount"
            type="number"
            value={claimForm.amount}
            onChange={(e) => setClaimForm({ ...claimForm, amount: parseFloat(e.target.value) || 0 })}
            required
          />
          <PrimaryButton type="submit">Submit Claim</PrimaryButton>
        </form>
      </div>
      <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
        <h3 className="text-lg font-medium text-slate-700 mb-3">Claims</h3>
        <ul className="space-y-2">
          {claims.map((claim) => (
            <li key={claim.id} className="rounded-lg bg-slate-50 p-3 text-sm text-slate-700">
              Claim {claim.id} for Patient {claim.patientId} - ${claim.amount} - Status: {claim.status}
            </li>
          ))}
        </ul>
      </div>
      <h3>Debtors</h3>
      <ul>
        {debtors.map(debtor => (
          <li key={debtor.id}>{debtor.name} - Owed: ${debtor.amountOwed} - Status: {debtor.status}</li>
        ))}
      </ul>
      <h3>Creditors</h3>
      <ul>
        {creditors.map(creditor => (
          <li key={creditor.id}>{creditor.name} - Owed: ${creditor.amountOwed} - Status: {creditor.status}</li>
        ))}
      </ul>
    </div>
  );
};

export default Accounts;